import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer, lazyProvider } from '@1inch-community/core/lazy';
import { observe } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/card';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { defer } from 'rxjs';
import '../../shared-elements/token-list';
import { walletAccountContext } from './context';
import './elements/wallet-account-header';
import { walletAccountViewStyle } from './wallet-account-view.style';
import { WalletAccountContext } from './wallet-account.context';
let WalletAccountView = class WalletAccountView extends LitElement {
    constructor() {
        super(...arguments);
        this.applicationContext = lazyAppContextConsumer(this);
        this.walletAccountContext = lazyProvider(this, { context: walletAccountContext });
        this.chainListView$ = defer(() => this.walletAccountContext.value.chainFilter$);
        this.activeAddress$ = defer(() => this.walletAccountContext.value.connectedWalletAddress$);
    }
    static { this.tagName = 'inch-wallet-account-view'; }
    static { this.styles = walletAccountViewStyle; }
    initContext() {
        if (!this.applicationContext) {
            return;
        }
        this.walletAccountContext.set(new WalletAccountContext(this.applicationContext.value.wallet, this.applicationContext.value.tokenStorage, this.applicationContext.value.storage));
    }
    render() {
        this.initContext();
        return html `
      <inch-token-list
        type="flat"
        showOnlyWithBalance
        .mobileView="${this.mobileView}"
        .chainIds="${observe(this.chainListView$)}"
        .walletAddress="${observe(this.activeAddress$)}"
        .header="${() => html ` <inch-wallet-account-header></inch-wallet-account-header>`}"
      ></inch-token-list>
    `;
    }
};
__decorate([
    property({ type: Boolean, attribute: true }),
    __metadata("design:type", Boolean)
], WalletAccountView.prototype, "mobileView", void 0);
WalletAccountView = __decorate([
    customElement(WalletAccountView.tagName)
], WalletAccountView);
export { WalletAccountView };
//# sourceMappingURL=wallet-account.view.js.map